"use client";

import { cva, type VariantProps } from "cva";
import { cn } from "#ui-atoms/lib/utils";
import { BaseFieldRoot, type BaseFieldRootProps } from "./field-root";

const conEdisonFieldRootVariants = cva({
  base: [
    "relative flex w-full flex-col",
    "@container/form-item", // used for container queries
    [
      // styling for floating label
      "relative",
      "[&_label]:absolute [&_label]:top-16 [&_label]:text-[1.125rem] [&_label]:leading-7",
      "focus-within:[&_label]:top-10 focus-within:[&_label]:text-sm focus-within:[&_label]:leading-5", // move label up on focus
    ],
  ],
  variants: {
    variant: {
      default: "",
      centered: { true: "items-center", false: undefined },
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export interface ConEdisonFieldRootProps
  extends Omit<BaseFieldRootProps, "variant"> {
  variant?: VariantProps<typeof conEdisonFieldRootVariants>["variant"];
}

export default function ConEdisonFieldRoot({
  className,
  variant,
  ...props
}: ConEdisonFieldRootProps) {
  return (
    <BaseFieldRoot
      {...props}
      className={cn(
        conEdisonFieldRootVariants({
          variant,
          className,
        }),
        className,
      )}
    />
  );
}
